import { CurrencyContext, LocaleContext } from '@tock/coretypes';
import { FunctionComponent } from 'react';
import { IntlProvider } from 'react-intl';

interface SearchContextProps {
  locale?: string;
  currencyCode?: string;
}

/**
 * Search context sets up an overall currency and locale context for the page, and passes
 * a mode {SearchMode} to the useSearchHandlers hook. All components in this context
 * should use the handlers from the {SearchHandlerContext}.
 * @param {SearchContextProps} searchContextProps
 */
export const SearchLandingContext: FunctionComponent<SearchContextProps> = ({
  currencyCode = 'USD',
  locale = 'en-us',
  children,
}) => {
  return (
    <IntlProvider locale={locale}>
      <CurrencyContext.Provider value={currencyCode}>
        <LocaleContext.Provider value={locale}>{children}</LocaleContext.Provider>
      </CurrencyContext.Provider>
    </IntlProvider>
  );
};
